import { render, staticRenderFns } from "./Didi.vue?vue&type=template&id=30d6f746"
import script from "./Didi.vue?vue&type=script&lang=js"
export * from "./Didi.vue?vue&type=script&lang=js"
import style0 from "./Didi.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Didi.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports